/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';

import { RootState, useTivoSelector } from '../../core/tivo/tivo-redux-wrapper';

const URLChangeEvents: FunctionComponent = (): JSX.Element => {
    const urlChangeEvents = useTivoSelector((state: RootState) => state.urlChangeEvents);
    const { url } = urlChangeEvents;
    // Used window.location.origin as base for relative path from redux
    const oUrl = new URL(url, window.location.origin);
    return <Navigate to={{ pathname: oUrl.pathname, search: oUrl.search }} />;
};

export default URLChangeEvents;
